var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-row',{attrs:{"no-gutters":"","justify":"start"}},[_c('v-icon',{staticClass:"mt-0 mr-1",attrs:{"color":_vm.iconColor}},[_vm._v("mdi-account-circle")]),_vm._v(" "+_vm._s(_vm.lastAccess)+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }